import { createClient } from 'contentful';
var validateParameters = function validateParameters() {
  // eslint-disable-next-line prefer-destructuring
  var CONTENTFUL_SPACE = process.env.CONTENTFUL_SPACE;
  // eslint-disable-next-line prefer-destructuring
  var CONTENTFUL_ACCESS_TOKEN = process.env.CONTENTFUL_ACCESS_TOKEN;
  if (!CONTENTFUL_SPACE || !CONTENTFUL_ACCESS_TOKEN) {
    throw new Error("Invalid contentful setup CONTENTFUL_SPACE: ".concat(CONTENTFUL_SPACE, " CONTENTFUL_ACCESS_TOKEN: ").concat(CONTENTFUL_ACCESS_TOKEN));
  }
};
export var getContentfulData = function getContentfulData(params) {
  validateParameters();
  return createClient({
    space: process.env.CONTENTFUL_SPACE,
    accessToken: process.env.CONTENTFUL_ACCESS_TOKEN
  }).getEntries(params);
};